import React, { useState } from 'react';
import Button from 'components/buttons/Button';
import { PlayCircle } from 'react-feather';
import BaseModal from 'components/modals/BaseModal';

const NikonVideo = () => {
    const [videoOpened, setVideoOpened] = useState(false);

    return (
        <>
            <div className={'container'}>
                <h2 className="text-center text-brand">Nikon Z 30 za vlogerje in vplivneže</h2>
                <div className="mt-6 flex justify-center">
                    <div className="max-w-full w-[400px] h-[200px] lg:w-[600px] lg:h-[300px] rounded-2xl overflow-hidden relative flex justify-center items-center shadow-2xl">
                        <img
                            src="/images/foto-izbor/nikon-video-placeholder.jpg"
                            alt=""
                            className="absolute w-full h-full object-cover"
                            loading="lazy"
                        />
                        <div className="z-10">
                            <Button color="secondary" startIcon={<PlayCircle />} onClick={() => setVideoOpened(true)}>
                                Predvajaj video
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            <BaseModal open={videoOpened} handleClose={() => setVideoOpened(false)}>
                <div className="w-full h-full sm:w-auto sm:h-auto flex flex-col justify-between gap-8">
                    <div className="header sm:hidden p-6 text-center">
                        <h3>Nikon Z 30</h3>
                    </div>
                    <div className="video flex-grow sm:w-[560px] sm:h-[315px] lg:w-[800px] lg:h-[450px]">
                        <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/lRqQoYGAOFo"
                            title="Nikon Z 30"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            className="max-w-full"
                        />
                    </div>
                    <div className="footer sm:hidden text-right p-8">
                        <Button onClick={() => setVideoOpened(false)} variant="outlined" color="secondary">
                            Zapri video
                        </Button>
                    </div>
                </div>
            </BaseModal>
        </>
    );
};

export default NikonVideo;
